import {
  addPlusToPhoneNumber,
  parsePhoneNumber,
} from 'features/call/call-base/helpers';
import { userStateMock } from 'features/user/mocks';
import type { VoiceSessionResponse } from 'features/voice-session/interfaces';

// Matches AppConfigService default for DefaultOutboundCallerId_English.
// Kept as a constant so this mock does not read AppConfig at module load
// (many tests provide partial AppConfigService mocks).
const DEFAULT_OUTBOUND_CALLER_ID_ENGLISH = '8663278877';

export const createVoiceSessionMock: VoiceSessionResponse = {
  participants: [
    {
      id: 'e5b62b38-e23c-4af3-ab40-8fb2c4710dae',
      state: 'awaitingAgent',
      type: 'agent',
      agentId: userStateMock.user.agentNumber,
      chimeAttendee: {
        attendeeId: '2159b13d-3203-dd93-911d-12778f23c967',
        externalUserId: 'e5b62b38-e23c-4af3-ab40-8fb2c4710dae',
      },
    },
    {
      id: 'f64e03c8-0601-44f5-8d51-bc574235e68c',
      state: 'awaitingAgent',
      type: 'hearing',
      direction: 'outbound',
      fromPhoneNumber: addPlusToPhoneNumber(
        parsePhoneNumber(DEFAULT_OUTBOUND_CALLER_ID_ENGLISH)
      ),
      dialString: '+18015757669',
      chimeAttendee: {
        attendeeId: 'dce81953-e204-f388-0fc5-77ce8eabe8b8',
        externalUserId: 'f64e03c8-0601-44f5-8d51-bc574235e68c',
      },
    },
  ],
  sessionHref: '/session/b06113c5-9e87-41a9-9098-007dc1b39a4c',
  chimeMeeting: {
    ExternalMeetingId: 'b06113c5-9e87-41a9-9098-007dc1b39a4c',
  },
};
